import { Button, Divider, Space } from 'antd';

import type { PopupRenderType } from '@app/components/MultipleSelect/MultipleSelect.types';

export const popupRender: PopupRenderType =
  ({
    showActions,
    dropdownDataTestId,
    selectAll,
    unselectAll,
    isEmptyOptions,
  }) =>
  (menu) => {
    const processedMenu = isEmptyOptions ? (
      <div data-testid="no-data">{menu}</div>
    ) : (
      menu
    );

    return (
      <div
        {...(dropdownDataTestId && {
          'data-testid': dropdownDataTestId,
        })}
      >
        {showActions && (
          <>
            <Space style={{ padding: '0 8px 4px' }} direction="vertical">
              <Button
                type="link"
                size="small"
                onClick={selectAll}
                data-testid="select-all"
              >
                Выбрать всё
              </Button>
              <Button
                type="link"
                size="small"
                onClick={unselectAll}
                data-testid="clear-all"
              >
                Очистить всё
              </Button>
            </Space>
            <Divider style={{ margin: '8px 0' }} />
          </>
        )}
        {processedMenu}
      </div>
    );
  };
